module.exports = __webpack_public_path__ + "static/media/sleeping_car.1e51edd3.png";